/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FlagShipmentRequest
 */
export interface FlagShipmentRequest {
    /**
     * 
     * @type {string}
     * @memberof FlagShipmentRequest
     */
    shipmentId: string;
    /**
     * What's wrong, in the customer's own words. Shown to operations as-is.
     * @type {string}
     * @memberof FlagShipmentRequest
     */
    message: string;
}

/**
 * Check if a given object implements the FlagShipmentRequest interface.
 */
export function instanceOfFlagShipmentRequest(value: object): value is FlagShipmentRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function FlagShipmentRequestFromJSON(json: any): FlagShipmentRequest {
    return FlagShipmentRequestFromJSONTyped(json, false);
}

export function FlagShipmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlagShipmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
        'message': json['message'],
    };
}

  export function FlagShipmentRequestToJSON(json: any): FlagShipmentRequest {
      return FlagShipmentRequestToJSONTyped(json, false);
  }

  export function FlagShipmentRequestToJSONTyped(value?: FlagShipmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
        'message': value['message'],
    };
}

